// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"232":"506cb170","671":"16c06505","850":"b55b1114","893":"2ab9ae20","901":"b8fb1d1e"}[chunkId] + ".js";
};